import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ProductRoutingModule } from './product-routing.module';
import { ProductComponent } from './product.component';
import { AddEditProductComponent } from './add-edit-product/add-edit-product.component';
import { DynamicFormModule } from 'src/app/shared/dynamic-form/dynamic-form.module';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { SharedModule } from 'src/app/shared/shared.module';
import { DirectiveModule } from 'src/app/shared/directive/directive.module';
import { MatDialogModule } from '@angular/material/dialog';
import { ProductsImportComponent } from './products-import/products-import.component';
import { FileUploadModule } from 'ng2-file-upload';
import { MatStepperModule } from '@angular/material/stepper';
import { ZipImportComponent } from './zip-import/zip-import.component';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { CatNavigationComponent } from './cat-navigation/cat-navigation.component';
import { ImageImportComponent } from './image-import/image-import.component';
import { ProductLinkComponent } from './product-link/product-link.component';
import { MatChipsModule } from '@angular/material/chips';
import { SafepipeModule } from 'src/app/shared/safepipe/safepipe.module';
import { RestrictionPopUpModule } from 'src/app/shared/restriction-pop-up/restriction-pop-up.module';
import { CommonProductModule } from 'src/app/shared/common-product/common-product.module';
import { CommonFileUploadModule } from 'src/app/global/common-file-upload/common-file-upload.module';
import { CommonImagesModule } from '../../common-images/common-images.module';
import { XlMapperComponent } from './xl-mapper/xl-mapper.component';
import { ModuleNameModule } from 'src/app/shared/module-name-pipe/modulename.module';
import { TrialExipedMessageModule } from 'src/app/shared/trial-exiped-message/trial-exiped-message.module';
import { MediaUploadModule } from './media-upload/media-upload.module';


@NgModule({
  declarations: [ProductComponent, AddEditProductComponent,
    ProductsImportComponent, ZipImportComponent, CatNavigationComponent,
    ImageImportComponent, ProductLinkComponent, XlMapperComponent],
  imports: [
    CommonModule,
    ProductRoutingModule,
    DynamicFormModule,
    MatCheckboxModule,
    SharedModule,
    DirectiveModule,
    MatDialogModule,
    FileUploadModule,
    MatStepperModule,
    NgxMatSelectSearchModule,
    MatChipsModule,
    SafepipeModule,
    RestrictionPopUpModule,
    CommonProductModule,
    CommonFileUploadModule,
    CommonImagesModule,
    ModuleNameModule,
    TrialExipedMessageModule,
    MediaUploadModule,
  ],
  exports: [AddEditProductComponent, DynamicFormModule, MediaUploadModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ProductModule { }
